import { create } from 'zustand';

import { FilesUploadResponse } from '@services/types';

type AdminPanelState = {
    isOpen: boolean;
    toggle: () => void;
    filesUploadResponse: FilesUploadResponse | null;
    setFilesUploadResponse: (message: FilesUploadResponse | null) => void;
    clearFilesUploadResponse: () => void;
};

export const useAdminPanelStore = create<AdminPanelState>((set) => ({
    isOpen: false,
    toggle: () => set((state) => ({ isOpen: !state.isOpen })),
    filesUploadResponse: null,
    setFilesUploadResponse: (message) => set({ filesUploadResponse: message }),
    clearFilesUploadResponse: () => set({ filesUploadResponse: null }),
}));
